import { api } from "@/shared/api/api";
import { AxiosRequestConfig } from "axios";

/**
 * Baixa um arquivo como Blob. Em caso de erro, a API responde com JSON, mas o
 * axios o entrega como Blob (por causa do responseType); aqui o corpo é convertido
 * de volta para objeto, para que formatMessageError consiga ler a mensagem.
 */
export const getBlob = async (url: string, config?: AxiosRequestConfig) => {
  try {
    const { data } = await api.get<Blob>(url, {
      ...config,
      responseType: "blob",
    });
    return data;
  } catch (error) {
    const axiosError = error as any;
    if (error instanceof Error && "response" in error) {
      if (axiosError.response?.data instanceof Blob) {
        const text = await axiosError.response.data.text();
        try {
          const jsonError = JSON.parse(text);
          axiosError.response.data = jsonError;
        } catch {
          axiosError.response.data = { detail: text };
        }
      }
    }

    throw error;
  }
};
